export default params => Object.keys(params).reduce((result, key) => {
    if (params[key]) {
        return { ...result, [key]: params[key] };
    }
    return result;
}, {});
